import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';

import * as DataSourceActions from './datasource.actions';
import { DataSourceControllerService } from '@rappider/rappider-sdk';
import { NotificationService } from 'libs/components/src/lib/services';
import { FullPaths } from '@rappider/shared/definitions';
import { Router } from '@angular/router';

@Injectable()
export class DataSourceEffects {
  constructor(
    private actions$: Actions,
    private dataSourceControllerService: DataSourceControllerService,
    private notificationService: NotificationService,
    private router: Router
  ) { }

  getDataSources$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        DataSourceActions.GetDataSources
      ),
      mergeMap((action) => {
        return this.dataSourceControllerService.find().pipe(
          mergeMap((datasources) => {
            return [
              DataSourceActions.GetDataSourcesSuccessful({ payload: { datasources } }),
            ];
          }), catchError(error => {
            return [
              DataSourceActions.GetDataSourcesFailure({ payload: { error, key: 'GetDataSources', timestamp: Date.now() } })
            ];
          }
          ));
      }
      )
    )
  );

  resetDataSource$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        DataSourceActions.ResetDataSource
      ),
      mergeMap((action) => {
        const params = {
          id: action.payload.id
        }
        return this.dataSourceControllerService.reset(params).pipe(
          map(() => {
            this.notificationService.createNotification(
              'success',
              'Success',
              'Data Source Updated'
            );
            return DataSourceActions.ResetDataSourceSuccessful();
          }), catchError(error => {
            return [
              DataSourceActions.ResetDataSourceFailure({ payload: { error, key: 'ResetDataSource', timestamp: Date.now() } })
            ];
          }
          ));
      }
      )
    )
  );

  updateDataSourceById$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        DataSourceActions.UpdateDataSource
      ),
      mergeMap((action) => {
        const params = {
          id: action.payload.id,
          body: action.payload.body
        }
        return this.dataSourceControllerService.updateById(params).pipe(
          map(() => {
            this.notificationService.createNotification(
              'success',
              'Success',
              'Data Source Updated'
            );
            return DataSourceActions.UpdateDataSourceSuccessful();
          }), catchError(error => {
            return [
              DataSourceActions.UpdateDataSourceFailure({ payload: { error, key: 'UpdateDataSource', timestamp: Date.now() } })
            ];
          }
          ));
      }
      )
    )
  );

}
